import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/prd-a/cs-mobile-next/app/components/product-detail/AddonDeals.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/prd-a/cs-mobile-next/app/components/product-detail/Combination.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/prd-a/cs-mobile-next/app/components/product-detail/CustomerReviews.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/prd-a/cs-mobile-next/app/components/product-detail/ProductDescription.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductQtyProvider"] */ "/home/crazysal/prd-a/cs-mobile-next/app/components/product-detail/ProductQtyContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/prd-a/cs-mobile-next/app/components/product-detail/ProductShipping.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/prd-a/cs-mobile-next/app/components/product-detail/RecommendList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/prd-a/cs-mobile-next/app/components/product-detail/SimilarProduct.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/prd-a/cs-mobile-next/app/components/product-detail/Swiper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/crazysal/prd-a/cs-mobile-next/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/crazysal/prd-a/cs-mobile-next/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/crazysal/prd-a/cs-mobile-next/styles/product-detail/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/crazysal/prd-a/cs-mobile-next/styles/global/bread-crumb.module.scss");
;
import(/* webpackMode: "eager" */ "/home/crazysal/prd-a/cs-mobile-next/styles/product-detail/product-info.module.scss");
;
import(/* webpackMode: "eager" */ "/home/crazysal/prd-a/cs-mobile-next/utils/react-vant.ts");
